import * as React from 'react';
import styled from 'styled-components';

import { Alert } from 'components/bootstrap';
import { Col, Row } from 'common/components';
import { MarkdownPreview } from 'components/common/MarkdownEditor';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import AssocEntities from './AssocEntities';
import StepListView from './StepListView';

const SectionHeaderRow = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.input.border};
  padding-bottom: ${({ theme }) => theme.spacings.sm};
`;

type Props = {
  eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>;
  descriptionMaxHeight?: number | string;
  row?: boolean;
  withAssocEntities?: boolean;
  eventId?: string;
};

function EventProcedureDetailsView({
  eventProcedure,
  descriptionMaxHeight = 250,
  row = false,
  withAssocEntities = false,
  eventId = undefined,
}: Props) {
  const Container = row ? Row : Col;

  return (
    <Container $align="stretch">
      <Col>
        <SectionHeaderRow>
          <h5>Description</h5>
        </SectionHeaderRow>
        {eventProcedure?.description ? (
          <MarkdownPreview
            show
            maxHeight={descriptionMaxHeight}
            noBackground
            noBorder
            value={eventProcedure.description}
            noPadding
          />
        ) : (
          <Alert style={{ width: '100%' }}>No description set</Alert>
        )}
      </Col>
      <Col>
        {withAssocEntities && (
          <>
            <SectionHeaderRow>
              <h5>Associated Entities</h5>
            </SectionHeaderRow>
            {eventProcedure?.associated_entities?.entity_count > 0 ? (
              <AssocEntities associatedEntities={eventProcedure.associated_entities} />
            ) : (
              <Alert style={{ width: '100%' }}>No associated entites</Alert>
            )}
          </>
        )}
        <SectionHeaderRow>
          <h5>Event Procedure Steps</h5>
        </SectionHeaderRow>
        {eventProcedure?.steps?.length > 0 ? (
          <StepListView steps={eventProcedure.steps} eventId={eventId} />
        ) : (
          <Alert style={{ width: '100%' }}>No steps added</Alert>
        )}
      </Col>
    </Container>
  );
}

export default EventProcedureDetailsView;
